import React, { createContext, useContext, useState } from 'react';

const SearchBarContext = createContext();

export const SearchBarProvider = ({ children }) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const toggleSearch = () => setIsSearchOpen(prev => !prev);
  const openSearch = () => setIsSearchOpen(true);
  const closeSearch = () => setIsSearchOpen(false);

  return (
    <SearchBarContext.Provider value={{ isSearchOpen, toggleSearch, openSearch, closeSearch }}>
      {children}
    </SearchBarContext.Provider>
  );
};

export const useSearchBar = () => useContext(SearchBarContext);
